<template>
	<div
		class="tab-item"
		:class="{ 'tab-item--show': show }"
		:aria-labelledby="name"
		role="tabpanel"
		tabindex="0"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'TabItem',
	props: {
		name: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			show: false,
		};
	},
	method: {
		toggleTab(tabName) {
			this.show = tabName === this.name;
		},
	},
	watch: {
		'$parent.tab': {
			handler(currentTabName) {
				this.show = currentTabName === this.name;
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.tab-item {
	display: none;
	outline: none;
	&--show {
		display: block;
	}
}
</style>
